import Declaration from './declaration.json';
import document from './document';
import Error from './error.json';
import Form from './form.json';
import Page from './page.json';
import Payment from './payment.json';
import Plan from './plan.json';
import Quotation from './quotation.json';
import Review from './review.json';

export const my = {
  translation: {
    ...Page,
    ...Form,
    ...Quotation,
    ...Plan,
    ...Declaration,
    ...Payment,
    ...Review,
    ...Error,
  },
  document,
};
